import { generatePath } from 'react-router-dom';

export const buildPath = (pattern: string, params: Record<string, string | undefined>): string => {
  const cleanedParams = Object.fromEntries(
    Object.entries(params)
      .filter(([_, value]) => value !== undefined && value !== '')
      .map(([key, value]) => [key, value?.replace(/^\/+/, '')]),
  );

  return generatePath(pattern, cleanedParams);
};
